<template>
  <div v-show="item">
    <div class="title">
      <div class="index">{{ item.title }}</div>
      <div class="sx">
        <div class="total">
          ({{ item.sx_txt }})
          <p>总数:{{item.total}}</p>
          </div>
        <div class="submit">
          <el-input v-model="num" onkeyup="value=value.replace(/[^\d]/g,'')"  @input="onChange" @focus="onFouce" name="item" @keyup.enter.native="onBuy">
            <el-button slot="append" @click="onBuy">下单</el-button>
          </el-input>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: null,
    index: 0,
    iindex:0,
  },
  data() {
    return {
        num:"",
    };
  },
  methods:{
      onChange(val)
      {
          this.num = parseInt(val);
      },
      onFouce()
      {
          this.num = "";
      },
      onBuy()
      {
          console.log("num:",this.num,"index:",this.index);
          if(this.num>0)
          {
            this.$emit("buy",this.num,this.index,this.iindex);
            this.num = "";
          }
          
      }
  }
};
</script>

<style lang="less" scoped>
.title {
  font-size: 13px;
  color: black;
  font-weight: bold;
  display: flex;
  .index{
      font-size: 30px;
      width:50px;
      line-height: 44px;
      text-align: center;
      box-sizing: border-box;
  }
  .sx {
    flex: 1;
    text-align: right;
    
    .total{
      line-height: 22px;
        display:flex;
        p{
          flex:1;
        }
    }
    
    .submit {
      text-align: center;
      /deep/.el-input__inner{
          line-height: 22px !important;
          height: 22px !important;
          padding: 0px;
        }
    }
  }
}


</style>